/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

/** Components */
import BaseLayout from './BaseLayout';
import BasicMathKeypad from '../keypads/BasicMath';

class DefaultLayout extends Component {
  render() {
    return (
      <div className="keypad-layout default clearfix">
        <BaseLayout {...this.props} />
        <BasicMathKeypad
          onKeyPressWrite={this.props.onKeyPressWrite}
          onKeyPressCmd={this.props.onKeyPressCmd}
          onTextModeChange={this.props.onTextModeChange}
        />
      </div>
    );
  }
}

export default DefaultLayout;
